export {useIsMobileDevice} from '../../../src/utils/useIsMobileDevice';
